import { createNativeStackNavigator } from '@react-navigation/native-stack';
import React from 'react';

// Screen imports - only the screens we actually need
import { ContactsDashboardScreen } from '../../screens/tasks/contacts/ContactsDashboardScreen';
import { ContactsDataScreen } from '../../screens/tasks/contacts/ContactsDataScreen';
import { ContactsInputScreen } from '../../screens/tasks/contacts/ContactsInputScreen';
import { ContactsIntroScreen } from '../../screens/tasks/contacts/ContactsIntroScreen';

const Stack = createNativeStackNavigator();

const ContactsStackNavigator = () => (
  <Stack.Navigator screenOptions={{ headerShown: false }}>
    <Stack.Screen name="ContactsDashboardScreen" component={ContactsDashboardScreen} />
    <Stack.Screen name="ContactsInputScreen" component={ContactsInputScreen} />
    <Stack.Screen name="ContactsIntroScreen" component={ContactsIntroScreen} />
    <Stack.Screen name="ContactsDataScreen" component={ContactsDataScreen} />
  </Stack.Navigator>
);

export default ContactsStackNavigator;
